import dateHelpers from '@u/helpers/dateHelpers'

/**
 * Date shown on a task (creation, due, funeral): date and time, or the date only when
 * the time was left undefined, as the due date always did.
 */
export const formatTaskDate = (
  value: string | null | undefined,
  undefinedTime: boolean | null | undefined
): string =>
  value ? dateHelpers.formatDate(value, undefinedTime ? 'll' : 'lll') : ''
